import { Component } from "react";
import * as React from "react";
import { fetchServerLevelLeaderboard, ServerType } from "../../services/ApiContext";
import Header from "../../components/Header/Header";
import Menu from "../../components/Menu/Menu";
import PageContainer from "../../containers/PageContainer";
import ServerLeaderboardInterface from "../../objects/ServerLeaderboardInterface";
import { resolveRankByString } from "../../utils/Badges";
import { Link } from "react-router-dom";
import ContentLoading from "../../components/Others/ContentLoading";
import { formatNumber } from "../../utils/NumberUtils";

interface IProps {
	serverType: ServerType;
	disablePercentage: boolean;
	headerText: string;
	headerWarning?: string | undefined;
}

class ServerLevelsLeaderboardPage extends Component<IProps, any> {

	constructor(props: IProps) {
		super(props);
		this.state = {
			apiData: null
		};
	}

	public async componentDidMount() {
		const apiData = await fetchServerLevelLeaderboard(this.props.serverType);
		this.setState({
			apiData: apiData
		});
	}

	public isNumber(value: any) {
		return typeof value === 'number';
	}

	public render() {
		if (this.state.apiData === null) {
			return (
				<PageContainer>
					<Header/>
					<main id="main-container">
						<Menu/>
						<div className="content content-full">
							<div
								className="col-xl-12 col-md-12 col-sm-12 text-xl-center text-md-center text-sm-center pt-lg-9 pb-lg-10">
								<ContentLoading/>
							</div>
						</div>
					</main>
				</PageContainer>
			);
		}
		if (this.props.disablePercentage) {
			return (
				<PageContainer>
					<Header/>
					<main id="main-container">
						<Menu/>
						<div className="content content-full">
							<h1>{this.props.headerText}</h1>
							<div className="block block-rounded block-bordered">
								{this.props.headerWarning !== undefined ?
									<div className="alert alert-warning alert-dismissable" style={{marginBottom: "0px"}} role="alert">
										<p className="mb-0">{this.props.headerWarning}</p>
									</div> : null
								}
								<div className="block-content block-content-full">
									<table
										className="table table-bordered table-striped table-vcenter js-dataTable-full">
										<thead>
										<tr>
											<th className="text-center" style={{width: '50px'}}>#</th>
											<th className="text-center" style={{width: '100px'}}>Rank</th>
											<th>Nick</th>
											<th className="d-none d-sm-table-cell text-center">Level</th>
										</tr>
										</thead>
										<tbody>
										{this.generateTable()}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</main>
				</PageContainer>
			);
		}

		// Default return s procenty v tabulce
		return (
			<PageContainer>
				<Header/>
				<main id="main-container">
					<Menu/>
					<div className="content content-full">
						<h1>{this.props.headerText}</h1>
						<div className="block block-rounded block-bordered">
							{this.props.headerWarning !== undefined ?
								<div className="alert alert-warning alert-dismissable" style={{marginBottom: "0px"}} role="alert">
									<p className="mb-0">{this.props.headerWarning}</p>
								</div> : null
							}
							<div className="block-content block-content-full">
								<table className="table table-bordered table-striped table-vcenter js-dataTable-full">
									<thead>
									<tr>
										<th className="text-center" style={{width: '50px'}}>#</th>
										<th className="text-center" style={{width: '100px'}}>Rank</th>
										<th>Nick</th>
										<th className="d-none d-sm-table-cell text-center">Level</th>
										<th className="d-none d-sm-table-cell text-center">Dokončení levelu</th>
										<th className="d-none d-sm-table-cell text-center">Do dalšího lvl</th>
									</tr>
									</thead>
									<tbody>
									{this.generateTable()}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</main>
			</PageContainer>
		);
	}

	public generateTable() {
		const apiData = this.state.apiData as ServerLeaderboardInterface[];
		let finalTable: any = [];
		apiData.forEach((player: ServerLeaderboardInterface) => {
			if (player.groups !== null) {
				if (this.props.disablePercentage) {
					finalTable.push(
						<tr key={player.index}>
							<td className="text-center">{player.index}</td>
							<td className="text-center">{resolveRankByString(player.groups!.primary)}</td>
							<td><Link to={"/player/" + player.nick}>{player.nick}</Link></td>
							<td className="text-center">{player.level}</td>
						</tr>
					);
				} else {
					console.log(player);
					finalTable.push(
						<tr key={player.index}>
							<td className="text-center">{player.index}</td>
							<td className="text-center">{resolveRankByString(player.groups!.primary)}</td>
							<td><Link to={"/player/" + player.nick}>{player.nick}</Link></td>
							<td className="text-center">{player.level}</td>
							<td className="text-center">{this.isNumber(player.percentage) ? player.percentage.toFixed(1) : "0%"}%</td>
							<td className="text-center">{formatNumber(player.toNextLevel - player.experience)} XP</td>
						</tr>
					);
				}
			} else {
				if (this.props.disablePercentage) {
					finalTable.push(
						<tr key={player.index}>
							<td className="text-center">{player.index}</td>
							<td className="text-center">{resolveRankByString('hrac')}</td>
							<td><Link to={"/player/" + player.nick}>{player.nick}</Link></td>
							<td className="text-center">{player.level}</td>
						</tr>
					);
				} else {
					finalTable.push(
						<tr key={player.index}>
							<td className="text-center">{player.index}</td>
							<td className="text-center">{resolveRankByString('hrac')}</td>
							<td><Link to={"/player/" + player.nick}>{player.nick}</Link></td>
							<td className="text-center">{player.level}</td>
							<td className="text-center">{player.percentage!.toFixed(1)}%</td>
							<td className="text-center">{formatNumber(player.toNextLevel! - player.experience!)} XP</td>
						</tr>
					);
				}
			}
		});
		return finalTable;
	}
}

export default ServerLevelsLeaderboardPage;
